import React from "react";

import useStyles from "./style";
import { useHistory } from "react-router-dom";

import ShoppingCartIcon from "@material-ui/icons/ShoppingCart";
import SearchIcon from "@material-ui/icons/Search";
import IconButton from "@material-ui/core/IconButton";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Badge from "@material-ui/core/Badge";
import { useState } from "react";
import { useEffect } from "react";

function ProdukDetail({ onClick, title, totalCart }) {
  const classes = useStyles();
  const history = useHistory();
  const [changeColor, setChangeColor] = useState(false);

  useEffect(() => {
    const changeNavbar = () => {
      if (window.scrollY >= 290) {
        setChangeColor(true);
      } else {
        setChangeColor(false);
      }
    };

    window.addEventListener("scroll", changeNavbar);

    return () => {
      window.removeEventListener("scroll", changeNavbar);
    };
  }, []);

  return (
    <div
      className={classes.header}
      style={!changeColor ? {} : { backgroundColor: "white" }}
    >
      <div className={classes.wrapHeader}>
        <div
          style={
            !changeColor
              ? { backgroundColor: "#f0f0f0", borderRadius: "50%" }
              : {}
          }
        >
          <IconButton size="small" onClick={() => history.goBack()}>
            <ArrowBackIcon className={classes.icCart} />
          </IconButton>
        </div>
        {/* <div className={classes.wrapTitle}>
          <Typography noWrap className={classes.title}>{title}</Typography>
        </div> */}
        <div style={{ display: "flex" }}>
          <div
            style={
              !changeColor
                ? {
                    backgroundColor: "#f0f0f0",
                    borderRadius: "50%",
                    marginRight: 10,
                  }
                : { marginRight: 10 }
            }
          >
            <IconButton size="small" onClick={() => history.push("/browse")}>
              <SearchIcon className={classes.icCart} />
            </IconButton>
          </div>
          <div
            style={
              !changeColor
                ? { backgroundColor: "#f0f0f0", borderRadius: "50%" }
                : {}
            }
          >
            <IconButton size="small" onClick={() => history.push("/cart")}>
              <Badge badgeContent={totalCart} color="secondary">
                <ShoppingCartIcon className={classes.icCart} />
              </Badge>
            </IconButton>
          </div>
        </div>
      </div>
    </div>
  );
}

export default ProdukDetail;
